<template>
  <div class>
    <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
        <span style="font-weight:600;color:#000; line-height: 10px;">机构信息</span>
    </div>
    <el-form :model="firstForm" ref="firstForm" :rules="rules" label-width="130px" style="width: 450px; margin-top: 20px;">
      <el-form-item label="机构名称" prop="name">
          <el-input
          v-model="firstForm.name"
          placeholder="请输入机构名称"
          ></el-input>
      </el-form-item>
      <el-form-item label="机构注册地址" prop="address">
          <el-input
          v-model="firstForm.address"
          placeholder="请输入机构注册地址"
          ></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="code">
          <el-input
          v-model="firstForm.code"
          placeholder="请输入统一社会信用代码"
          ></el-input>
      </el-form-item>
    </el-form>
  <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
    <span style="font-weight:600;color:#000; line-height: 10px;">联系信息</span>
  </div>
    <el-form :model="secondForm" ref="secondForm" :rules="rules" label-width="130px" style="width: 450px; margin-top: 20px;">
      <el-form-item label="联系人" prop="contactUser">
        <el-input v-model="secondForm.contactUser" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="contactNum">
        <el-input v-model="secondForm.contactNum" placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="contactAddress">
        <el-input v-model="secondForm.contactAddress" placeholder="请输入联系地址"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱" prop="email">
        <el-input v-model="secondForm.email" placeholder="请输入联系邮箱"></el-input>
      </el-form-item>
      <el-form-item label="备注说明" prop="remark">
        <el-input v-model="secondForm.remark" type="textarea" placeholder="请输入备注说明"></el-input>
      </el-form-item>
      <el-form-item style="display:flex;flex-direction: column;text-align: center;">
        <el-button @click="cancel" class="resetbtn">取消</el-button>
        <el-button type="success" @click="onSubmit(true)">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { regionData } from "element-china-area-data";
import { HOST, EV_HOST } from "@/utils/host";
export default {
  name: "xiugaiyuyingshang",
  components: {},
  data() {
    return {
      optionsThree: regionData, //省市区数据
      firstForm: {
        name: "",
        orgType: "",
        attr: "",
        prefix: "",
        address: "",
        code: "",
        city: "",
        invoice: "",
        creatTime: [],
        operatorName: "",
      },
      secondForm: {
        contactUser: "",
        contactNum: "",
        contactAddress: "",
        email: "",
        businessLicense: "",
        stationLogo: "",
        platformLogo: "",
        remark: "",
      },
      rules: {
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入机构注册地址', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
        ],
        contactUser: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        contactNum: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入联系邮箱', trigger: 'blur' },
        ],
      },
      imageUrl: "",
      imageUrl1: "",
      imageUrl2: "",
      id: "",
      isAttr: true,
      isPrefix: false,
      token: window.localStorage.getItem("token"),
      isHave: false,
    };
  },
  computed: {
    headers() {
      // console.log(token);
      return {
        token: window.localStorage.getItem("token")
      };
    },
    action() {
      return HOST + "/oss";
    }
  },
  methods: {
    async onSubmit(flag) {
      try {
          //必填校验
          await Promise.all([
              this.$refs.firstForm.validate(),
              this.$refs.secondForm.validate(),
          ]);
      } catch (error) {
          return;
      }
      if (!flag) {
        this.$router.go(-1)
        return;
      }
      if(this.firstForm.city && this.firstForm.city != '') {
        this.firstForm.city = this.firstForm.city.join(",");
        this.firstForm.cityName = this.$refs.three.getCheckedNodes()[0].pathLabels.join(" / ");
      } else {
        this.firstForm.city = '';
        this.firstForm.cityName = '';
      }

      let form = Object.assign(this.firstForm, this.secondForm)
      if (form.creatTime != []) {
        form.signStartTime = this.firstForm.creatTime[0]
        form.signEndTime = this.firstForm.creatTime[1]
      } else {
        form.signStartTime = ""
        form.signEndTime = ""
      }
      form.id = this.id
      this.$store.dispatch("form/handle", {
        url: "/org",
        data: form,
        method: "post",
        callback: resp => {
          this.$router.go(-1);
          this.$store.dispatch("login/getCur");
        }
      });
    },
    cancel(){
      this.$router.go(-1)
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.secondForm.businessLicense = res.data.fileName;
    },
    handleRemove(){
      this.imageUrl = ''
      this.secondForm.businessLicense = '';
    },
    handleAvatarSuccess1(res, file) {
      this.imageUrl1 = URL.createObjectURL(file.raw);
      this.secondForm.stationLogo = res.data.fileName;
    },
    handleRemove1(){
      this.imageUrl1 = ''
      this.secondForm.stationLogo = '';
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw);
      this.secondForm.platformLogo = res.data.fileName;
    },
    handleRemove2(){
      this.imageUrl2 = ''
      this.secondForm.platformLogo = '';
    },

    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png');
      const isLt2M = file.size <= 2097152;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/JEPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    isSelect(val) {
      console.log(val)
      if (val === 0) {
        this.isAttr = true
        this.isPrefix = false
      } else if (val === 1) {
        this.isPrefix = true
        this.isAttr = false
      } else if (val === 3) {
        this.isPrefix = true
        this.isAttr = true
      }
    },

    getDataDetail() {
      let data = {
          id: this.id
      }
      this.$store.dispatch("form/handle", {
      url: "/org/getDataDetail",
      method: "get",
      data: data,
      callback: resp => {

          console.log("resp2",resp)
          this.firstForm.name = resp.name
          this.firstForm.orgType = resp.orgType
          this.firstForm.prefix = resp.prefix
          this.firstForm.attr = resp.attr
          this.firstForm.address = resp.address
          this.firstForm.code = resp.code
          this.firstForm.invoice = resp.invoice
          this.firstForm.operatorName = resp.operatorName
          this.firstForm.creatTime = [resp.signStartTime, resp.signEndTime]
          this.secondForm.contactUser = resp.contactUser
          this.secondForm.contactNum = resp.contactNum
          this.secondForm.contactAddress = resp.contactAddress
          this.secondForm.email = resp.email
          this.secondForm.businessLicense = resp.businessLicense
          this.secondForm.stationLogo = resp.stationLogo
          this.secondForm.platformLogo = resp.platformLogo
          this.secondForm.remark = resp.remark
          this.firstForm.city = resp.city.split(",")

          if(this.secondForm.businessLicense){
            this.imageUrl = HOST + "/oss?objectName=" + resp.businessLicense + "&token=" + this.token
          }
          if(this.secondForm.stationLogo){
            this.imageUrl1 = HOST + "/oss?objectName=" + resp.stationLogo + "&token=" + this.token
          }
          if(this.secondForm.platformLogo){
            this.imageUrl2 = HOST + "/oss?objectName=" + resp.platformLogo + "&token=" + this.token
          }

          if (resp.prefix != "") {
            this.isHave = true
          } else {
            this.isHave = false
          }
          if (resp.orgType === 0) {
              this.isAttr = true
              this.isPrefix = false
            } else if (resp.orgType === 1) {
              this.isPrefix = true
              this.isAttr = false
            } else if (resp.orgType === 3) {
              this.isPrefix = true
              this.isAttr = true
            }
          }
      });
    },
  },
  mounted() {

  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
    this.getDataDetail()
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-upload__tip{
  color: #409EFF;
}

.el-upload-action {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0;
  color: #fff;
  text-align: center;
  line-height: 178px;

}
.el-upload-action:hover {
  font-size: 20px;
  background-color: #000;
  background-color: rgba(0, 0, 0, .3)
}
.resetbtn:hover {
  border: 1px solid #00cc00; 
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00; 
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/organManagement/modifyOperatormanagement.vue